import Layout from '@/layouts/BasicLayout/index.vue'
import type { RouteRecordRaw } from 'vue-router'

const inventory: RouteRecordRaw = {
  path: '/inventory',
  name: 'inventory',
  redirect: '/inventory/returns-manage',
  component: Layout,
  meta: {
    title: '库存管理',
    module: 'Inventory',
    icon: 'inventory|svg'
  },
  children: [
    // 退货管理
    {
      path: 'returns-manage',
      name: 'ReturnsManage',
      component: () => import('@/views/Inventory/ReturnsManage/index.vue'),
      meta: {
        title: '退货管理',
        module: 'RETURNS_MANAGE'
      }
    },
  ]
}

export default inventory
